import React from 'react';
import { Link } from 'react-router-dom';
interface ILessonsProps {
  user_status: any;
  cur_course: any;
  activeProgress: any;
  comingSoon: boolean;
  userHasBiteU: boolean;
}

const LessonsTab: React.FC<ILessonsProps> = (props: ILessonsProps) => {
  const { user_status, cur_course, activeProgress, comingSoon, userHasBiteU } = props;

  const completeCheck = <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.807 6.29825C13.9825 6.09941 14.2164 6 14.5088 6C14.7895 6 15.0234 6.09941 15.2105 6.29825C15.4094 6.48538 15.5088 6.7193 15.5088 7C15.5088 7.2807 15.4094 7.51462 15.2105 7.70175L9.31579 13.5965C9.10526 13.807 8.83626 13.9123 8.50877 13.9123C8.19298 13.9123 7.92398 13.807 7.70175 13.5965L4.80702 10.7018C4.60819 10.5263 4.50877 10.2924 4.50877 10C4.50877 9.7193 4.60819 9.48538 4.80702 9.29825C5.00585 9.09941 5.23977 9 5.50877 9C5.80117 9 6.03509 9.09941 6.21053 9.29825L9.10526 12.193C9.16374 12.2515 9.07602 12.2924 8.84211 12.3158C8.61988 12.3392 8.39181 12.3392 8.15789 12.3158C7.93567 12.2924 7.8538 12.2515 7.91228 12.193L13.807 6.29825ZM10 18C11.4971 18 12.8538 17.6491 14.0702 16.9474C15.2982 16.2456 16.2573 15.2865 16.9474 14.0702C17.6491 12.8421 18 11.4854 18 10C18 8.50292 17.6491 7.1462 16.9474 5.92982C16.2573 4.70175 15.2982 3.74269 14.0702 3.05263C12.8538 2.35088 11.4971 2 10 2C8.51462 2 7.15789 2.35088 5.92982 3.05263C4.71345 3.74269 3.75439 4.70175 3.05263 5.92982C2.35088 7.1462 2 8.50292 2 10C2 11.4854 2.35088 12.8421 3.05263 14.0702C3.75439 15.2865 4.71345 16.2456 5.92982 16.9474C7.15789 17.6491 8.51462 18 10 18ZM10 20C8.19883 20 6.52632 19.5556 4.98246 18.6667C3.45029 17.7661 2.23392 16.5497 1.33333 15.0175C0.444445 13.4737 5.96046e-08 11.8012 5.96046e-08 10C5.96046e-08 8.18713 0.444445 6.51462 1.33333 4.98246C2.23392 3.45029 3.45029 2.23977 4.98246 1.35088C6.52632 0.450292 8.19883 -4.76837e-07 10 -4.76837e-07C11.8129 -4.76837e-07 13.4854 0.450292 15.0175 1.35088C16.5497 2.23977 17.7602 3.45614 18.6491 5C19.5497 6.53216 20 8.19883 20 10C20 11.8012 19.5497 13.4737 18.6491 15.0175C17.7602 16.5497 16.5439 17.7661 15 18.6667C13.4678 19.5556 11.8012 20 10 20Z' fill='#47CD89'/>
  </svg>;

  const progressCheck = <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.807 6.29825C13.9825 6.09941 14.2164 6 14.5088 6C14.7895 6 15.0234 6.09941 15.2105 6.29825C15.4094 6.48538 15.5088 6.7193 15.5088 7C15.5088 7.2807 15.4094 7.51462 15.2105 7.70175L9.31579 13.5965C9.10526 13.807 8.83626 13.9123 8.50877 13.9123C8.19298 13.9123 7.92398 13.807 7.70175 13.5965L4.80702 10.7018C4.60819 10.5263 4.50877 10.2924 4.50877 10C4.50877 9.7193 4.60819 9.48538 4.80702 9.29825C5.00585 9.09941 5.23977 9 5.50877 9C5.80117 9 6.03509 9.09941 6.21053 9.29825L9.10526 12.193C9.16374 12.2515 9.07602 12.2924 8.84211 12.3158C8.61988 12.3392 8.39181 12.3392 8.15789 12.3158C7.93567 12.2924 7.8538 12.2515 7.91228 12.193L13.807 6.29825ZM10 18C11.4971 18 12.8538 17.6491 14.0702 16.9474C15.2982 16.2456 16.2573 15.2865 16.9474 14.0702C17.6491 12.8421 18 11.4854 18 10C18 8.50292 17.6491 7.1462 16.9474 5.92982C16.2573 4.70175 15.2982 3.74269 14.0702 3.05263C12.8538 2.35088 11.4971 2 10 2C8.51462 2 7.15789 2.35088 5.92982 3.05263C4.71345 3.74269 3.75439 4.70175 3.05263 5.92982C2.35088 7.1462 2 8.50292 2 10C2 11.4854 2.35088 12.8421 3.05263 14.0702C3.75439 15.2865 4.71345 16.2456 5.92982 16.9474C7.15789 17.6491 8.51462 18 10 18ZM10 20C8.19883 20 6.52632 19.5556 4.98246 18.6667C3.45029 17.7661 2.23392 16.5497 1.33333 15.0175C0.444445 13.4737 5.96046e-08 11.8012 5.96046e-08 10C5.96046e-08 8.18713 0.444445 6.51462 1.33333 4.98246C2.23392 3.45029 3.45029 2.23977 4.98246 1.35088C6.52632 0.450292 8.19883 -4.76837e-07 10 -4.76837e-07C11.8129 -4.76837e-07 13.4854 0.450292 15.0175 1.35088C16.5497 2.23977 17.7602 3.45614 18.6491 5C19.5497 6.53216 20 8.19883 20 10C20 11.8012 19.5497 13.4737 18.6491 15.0175C17.7602 16.5497 16.5439 17.7661 15 18.6667C13.4678 19.5556 11.8012 20 10 20Z' fill='#FDB022'/>
  </svg>;

  const defaultCheck = <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.807 6.29825C13.9825 6.09941 14.2164 6 14.5088 6C14.7895 6 15.0234 6.09941 15.2105 6.29825C15.4094 6.48538 15.5088 6.7193 15.5088 7C15.5088 7.2807 15.4094 7.51462 15.2105 7.70175L9.31579 13.5965C9.10526 13.807 8.83626 13.9123 8.50877 13.9123C8.19298 13.9123 7.92398 13.807 7.70175 13.5965L4.80702 10.7018C4.60819 10.5263 4.50877 10.2924 4.50877 10C4.50877 9.7193 4.60819 9.48538 4.80702 9.29825C5.00585 9.09941 5.23977 9 5.50877 9C5.80117 9 6.03509 9.09941 6.21053 9.29825L9.10526 12.193C9.16374 12.2515 9.07602 12.2924 8.84211 12.3158C8.61988 12.3392 8.39181 12.3392 8.15789 12.3158C7.93567 12.2924 7.8538 12.2515 7.91228 12.193L13.807 6.29825ZM10 18C11.4971 18 12.8538 17.6491 14.0702 16.9474C15.2982 16.2456 16.2573 15.2865 16.9474 14.0702C17.6491 12.8421 18 11.4854 18 10C18 8.50292 17.6491 7.1462 16.9474 5.92982C16.2573 4.70175 15.2982 3.74269 14.0702 3.05263C12.8538 2.35088 11.4971 2 10 2C8.51462 2 7.15789 2.35088 5.92982 3.05263C4.71345 3.74269 3.75439 4.70175 3.05263 5.92982C2.35088 7.1462 2 8.50292 2 10C2 11.4854 2.35088 12.8421 3.05263 14.0702C3.75439 15.2865 4.71345 16.2456 5.92982 16.9474C7.15789 17.6491 8.51462 18 10 18ZM10 20C8.19883 20 6.52632 19.5556 4.98246 18.6667C3.45029 17.7661 2.23392 16.5497 1.33333 15.0175C0.444445 13.4737 5.96046e-08 11.8012 5.96046e-08 10C5.96046e-08 8.18713 0.444445 6.51462 1.33333 4.98246C2.23392 3.45029 3.45029 2.23977 4.98246 1.35088C6.52632 0.450292 8.19883 -4.76837e-07 10 -4.76837e-07C11.8129 -4.76837e-07 13.4854 0.450292 15.0175 1.35088C16.5497 2.23977 17.7602 3.45614 18.6491 5C19.5497 6.53216 20 8.19883 20 10C20 11.8012 19.5497 13.4737 18.6491 15.0175C17.7602 16.5497 16.5439 17.7661 15 18.6667C13.4678 19.5556 11.8012 20 10 20Z' fill='#BDBEC1'/>
  </svg>;

  const checkLessonComplete = (name: string) => {
    const completed = activeProgress.completedLessons.filter((less: any) => {
      return less.name === name;
    });
    if (completed.length) {
      return true;
    }
    return false;
  };

  const checkLessonInProgress = (name: string) => {
    const arr = activeProgress.currentProgress.filter((less: any) => {
      return less.lesson.name === name;
    });

    if (arr[0].currentTime !== 0 && arr[0].currentTime !== 1) {
      return true;
    }
    return false;
  };

  if (!activeProgress || Object.keys(activeProgress).length === 0) {
    return (
      <div className='spinner-spacer-bite-u'>
        <div className='loader'>Loading...</div>
      </div>
    );
  }

  return (
    <div className='bite-u-tab-cont'>
      <h1>Videos</h1>
      {userHasBiteU ? (
        <div className='bite-u-lessons-table'>
          {activeProgress.currentProgress.map((lesson: any, i: number) => (
            <div className={i === cur_course.lessons.length - 1 ? 'bite-u-lesson-last' : 'bite-u-lesson'} key={i}>
              <div className='bite-u-lesson-icon'>
                {checkLessonComplete(lesson.lesson.name) ? completeCheck :
                  checkLessonInProgress(lesson.lesson.name) ? progressCheck :
                    defaultCheck}
              </div>
              <div className='bite-u-lesson-name-cont'>
                <h6>{lesson.lesson.name}</h6>
                {comingSoon ? (
                  <></>
                ) : (
                  <Link to={{
                    pathname: '/bite-u/course-training',
                    state: {
                      cur_course: cur_course,
                      user_status: user_status,
                      cur_lesson: lesson
                    },
                  }}
                  >
                    <h5>
                      {checkLessonComplete(lesson.lesson.name) ? 'Start Over' : checkLessonInProgress(lesson.lesson.name) ? 'Continue' : 'Start Lesson'}
                    </h5>
                  </Link>
                )}
              </div>
            </div>
          )
          )}
        </div>
      ) : (
        <div className='bite-u-lessons-table'>
          {activeProgress.currentProgress.map((lesson: any, i: number) => (
            <div className={i === cur_course.lessons.length - 1 ? 'bite-u-lesson-last' : 'bite-u-lesson'} key={i}>
              <div className='bite-u-lesson-name-cont'>
                <h6>{lesson.lesson.name}</h6>
              </div>
            </div>
          )
          )}
        </div>
      )}

    </div>
  );
};

export default LessonsTab;
